import React, { MouseEvent, useCallback } from 'react';
import classNames from 'classnames';

interface IProps<T> {
  values: Array<T>;
  onChange: (values: Array<T>) => void;
  className?: string;
}

const SelectAllControl = <T extends unknown>(props: IProps<T>) => {
  const { values, onChange, className } = props;

  const onSelect = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    onChange(values);
  }, [onChange, values]);

  const onClear = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    onChange([]);
  }, [onChange]);

  return (
    <div className={classNames('select-all-control', className)}>
      <button onClick={onSelect} className="btn__links">Select all</button>
      <button onClick={onClear} className="btn__links">Clear all</button>
    </div>
  )
}

export default SelectAllControl;
